import { render, staticRenderFns } from "./addCpmpanyCheck.vue?vue&type=template&id=995b0e30&scoped=true&"
import script from "./addCpmpanyCheck.vue?vue&type=script&lang=js&"
export * from "./addCpmpanyCheck.vue?vue&type=script&lang=js&"
import style0 from "./addCpmpanyCheck.vue?vue&type=style&index=0&id=995b0e30&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "995b0e30",
  null
  
)

export default component.exports